import { useMemo } from 'react';
import type { HttpRequest } from '../types/http-request';
import {
  buildProxyGrpcHarDisplayEntry,
  hasProxyGrpcHarEntry,
} from '../utils/proxyGrpcDisplay.utils';
import { useHarEntryBodyViewFromShape } from './useHarEntryBodyView';
import { useToolHarGrpcDecodeStore } from '../store/toolHarGrpcDecodeStore';

export function useProxyGrpcBodyView({
  applicationId,
  request,
  requestBody,
  responseBody,
}: {
  applicationId?: string;
  request: HttpRequest;
  requestBody?: string;
  responseBody?: string;
}) {
  const storedWebGrpcDecodedData = useToolHarGrpcDecodeStore(
    (state) => state.byRequestId[request.id],
  );

  const harEntryShape = useMemo(
    () =>
      buildProxyGrpcHarDisplayEntry({
        request,
        requestBody: requestBody ?? '',
        responseBody: responseBody ?? '',
        webGrpcDecodedData: storedWebGrpcDecodedData ?? null,
      }),
    [request, requestBody, responseBody, storedWebGrpcDecodedData],
  );

  const display = useHarEntryBodyViewFromShape({
    applicationId,
    harEntryShape,
    viewResetKey: request.id,
  });

  const hasGrpcHarEntry = hasProxyGrpcHarEntry({
    grpcHarDisplay: display.harEntry ?? undefined,
  });

  return {
    bodyView: display.bodyView,
    setBodyView: display.setBodyView,
    grpcHarDisplay: display.harEntry ?? undefined,
    harEntry: display.harEntry ?? undefined,
    hasGrpcHarEntry,
    hasGrpcBodyView: display.hasDecodedBodyView,
    showGrpcBodyViewToggle: display.showProtocolBodyViewToggle,
    showProtocolBodyViewToggle: display.showProtocolBodyViewToggle,
    editorProps: display.editorProps,
  };
}
